module.exports = __webpack_public_path__ + "static/img/12areaB_10.9f497d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_10.png
// module id = 1102
// module chunks = 1